import axios from 'axios';
var AxiosService = (function () {
    function AxiosService(props) {
        var url = props.url, method = props.method, body = props.body, _a = props.isFormData, isFormData = _a === void 0 ? false : _a, _b = props.token, token = _b === void 0 ? '' : _b, _c = props.noCache, noCache = _c === void 0 ? false : _c, timeout = props.timeout;
        this._url = url;
        this._method = method;
        this._body = body;
        this._isFormData = isFormData;
        this._token = token;
        this._noCache = noCache;
        this._timeout = timeout;
    }
    AxiosService.prototype.api = function () {
        var options = {
            url: this._url,
            method: this._method.toLowerCase(),
            headers: {
                'Content-Type': this._isFormData ? 'multipart/form-data' : 'application/json',
            },
            timeout: this._timeout || this._timeout === 0 ? this._timeout : 10000
        };
        if (this._token) {
            options.headers['Authorization'] = this._token;
        }
        if (this._noCache) {
            options.headers['Cache-Control'] = 'no-cache';
        }
        if (this._body) {
            options.data = this._body;
        }
        return new Promise(function (resolve, reject) {
            axios(options)
                .then(function (res) {
                resolve(res);
            })
                .catch(function (error) {
                if (error.response) {
                    reject(error.response);
                }
                else if (error.request) {
                    reject(error.request);
                }
                else {
                    reject(error);
                }
            });
        });
    };
    return AxiosService;
}());
export default AxiosService;
